import React, { useContext, useEffect, useState } from 'react'
import ImportFromExcelContext from '../../../../contexts/ImportFromExcelContext'
import UserContext from '../../../../contexts/UserContext'
import StockContext from '../../../../contexts/StockContext'
import io from 'socket.io-client'
import {
  Container,
  HeaderDiv,
  HeaderText,
  CloseDiv,
  CloseImg,
  SubText,
  ListItem,
  ErrorText,
  ProgressContainer,
  ProgressFill,
  SuccessText,
  ButtonsDiv,
  FinishButton,
  DisabledFinishButton,
  SecondaryButton,
  ErrorBox,
  LoadingContainer,
  LoadingBadge,
  LogSection,
  LogHeader,
  LogTitle,
  LogTabs,
  LogTab,
  LogList,
  LogCard,
  LogCardTop,
  LogBadge,
  LogCode,
  LogItemName,
  LogReason,
  LogSuccessMessage,
  LogEmpty,
} from './style'
import ModalContext from '../../../../contexts/ModalContext'
import cross from '../../../../assets/addStockModal/cross.svg'
import { OrdenoLoading } from '../../../OrdenoLoading'

const FollowingStep = () => {
  const { setImportFromExcelModal } = useContext(StockContext)
  const { setModalActive, setModalSection } = useContext(ModalContext)
  const { importError, setImportError, importResult } = useContext(ImportFromExcelContext)
  const [isInitialLoading, setIsInitialLoading] = useState<boolean>(true)
  const [stockPercentage, setStockPercentage] = useState<number>(0)
  const [successLines, setSuccessLines] = useState<number>(0)
  const [errorLines, setErrorLines] = useState<number>(0)
  const [createdInDataBaseLines, setCreatedInDataBaseLines] =
    useState<number>(0)
  const [updatedInDataBaseLines, setUpdatedInDataBaseLines] =
    useState<number>(0)
  const [updatedInOmieLines, setUpdatedInOmieLines] = useState<number>(0)
  const [showButton, setShowButton] = useState(false)
  const [updatedRecordsList, setUpdatedRecordsList] = useState<Array<{ line: number; code?: string; name?: string }>>([])
  const [errorRecordsList, setErrorRecordsList] = useState<Array<{ line: number; code?: string; reason: string }>>([])
  const [activeLogTab, setActiveLogTab] = useState<'errors' | 'updated'>('errors')

  const handleCloseModal = () => {
    setImportError(null)
    setImportFromExcelModal(false)
    setModalActive(false)
  }

  const handleGoBack = () => {
    setImportError(null)
    setModalSection('thirdExcelAdd')
  }

  useEffect(() => {
    if (stockPercentage === 100) {
      const timer = setTimeout(() => {
        setShowButton(true)
      }, 1000)

      return () => clearTimeout(timer)
    } else {
      setShowButton(false)
    }
  }, [stockPercentage])

  useEffect(() => {
    if (importResult) {
      if (Array.isArray(importResult.updatedRecords) && importResult.updatedRecords.length > 0) {
        setUpdatedRecordsList(importResult.updatedRecords)
      }
      if (Array.isArray(importResult.errorRecords) && importResult.errorRecords.length > 0) {
        setErrorRecordsList(importResult.errorRecords)
      }
      if (importResult.successCount !== undefined) {
        setSuccessLines(importResult.successCount)
      }
      if (importResult.errorCount !== undefined) {
        setErrorLines(importResult.errorCount)
      }
      if (importResult.createdInDatabaseCount !== undefined) {
        setCreatedInDataBaseLines(importResult.createdInDatabaseCount)
      }
      if (importResult.updatedInDatabaseCount !== undefined) {
        setUpdatedInDataBaseLines(importResult.updatedInDatabaseCount)
      }
      if (importResult.updatedInOmieCount !== undefined) {
        setUpdatedInOmieLines(importResult.updatedInOmieCount)
      }
    }
  }, [importResult])

  useEffect(() => {
    if (errorRecordsList.length > 0) {
      setActiveLogTab('errors')
    } else if (updatedRecordsList.length > 0) {
      setActiveLogTab('updated')
    }
  }, [errorRecordsList.length, updatedRecordsList.length])

  useEffect(() => {
    const rawUrl = process.env.REACT_APP_SOCKET_URL || window.location.origin
    const socketUrl = rawUrl.startsWith('ws') ? rawUrl.replace(/^ws/, 'http') : rawUrl
    const { token } = (window as any).localStorage ? { token: localStorage.getItem('token') } : { token: undefined }
    let triedPolling = false

    const createSocket = (transports: any[]) =>
      io(socketUrl, {
        auth: { token },
        query: { token },
        transports,
        reconnection: true,
        timeout: 5000,
        path: '/socket.io',
        autoConnect: false,
        forceNew: true,
      })

    let socket: any = createSocket(['websocket', 'polling'])

    const attachListeners = (sock: any) => {
      sock.on('conclusionsEvent', (payload: any) => {
        setIsInitialLoading(false)
        const {
          createdInDatabase = 0,
          updatedInDatabase = 0,
          updatedInOmie = 0,
          percentageComplete = 0,
          success = 0,
          error = 0,
          updatedRecords = [],
          errorRecords = [],
        } = payload || {}

        setStockPercentage(percentageComplete)
        setSuccessLines(success)
        setErrorLines(error)
        setCreatedInDataBaseLines(createdInDatabase)
        setUpdatedInDataBaseLines(updatedInDatabase)
        setUpdatedInOmieLines(updatedInOmie)

        if (Array.isArray(updatedRecords) && updatedRecords.length > 0) {
          setUpdatedRecordsList(updatedRecords)
        }
        if (Array.isArray(errorRecords) && errorRecords.length > 0) {
          setErrorRecordsList(errorRecords)
        }
      })

      sock.on('connect_error', (err: any) => {
        console.error('[FollowingStep] socket connect_error', err)
        if (!triedPolling) {
          triedPolling = true
          console.info('[FollowingStep] tentando fallback para polling')
          try {
            if (sock && typeof sock.close === 'function') sock.close()
          } catch (e) {
            console.warn('[FollowingStep] erro ao fechar socket antes do fallback', e)
          }
          socket = createSocket(['polling'])
          attachListeners(socket)
          try {
            socket.connect()
          } catch (e) {
            console.warn('[FollowingStep] erro ao conectar com polling', e)
          }
        }
      })
    }

    attachListeners(socket)

    try {
      socket.connect()
    } catch (e) {
      console.warn('[FollowingStep] erro ao iniciar conexão socket', e)
    }

    return () => {
      try {
        if (socket) {
          if (typeof socket.off === 'function') {
            socket.off('conclusionsEvent')
            socket.off('connect_error')
          }

          if (typeof socket.close === 'function') socket.close()
          else if (typeof socket.disconnect === 'function') socket.disconnect()
        }
      } catch (e) {
        console.warn('[FollowingStep] erro durante cleanup do socket', e)
      }
    }
  }, [])

  const ProgressBar = (props: any) => {
    const fillerStyles = {
      width: `${props.completion}%`,
    }

    return (
      <ProgressContainer>
        <ProgressFill style={fillerStyles} />
      </ProgressContainer>
    )
  }

  useEffect(() => {
    if (stockPercentage > 0 || successLines > 0 || errorLines > 0) {
      setIsInitialLoading(false)
    }
  }, [stockPercentage, successLines, errorLines])

  if (importError) {
    return (
      <Container>
        <HeaderDiv>
          <HeaderText style={{ color: '#d32f2f' }}>Falha na importação</HeaderText>
          <CloseDiv onClick={handleCloseModal}>
            <CloseImg src={cross} alt='Close tab' />
          </CloseDiv>
        </HeaderDiv>
        <SubText>Não foi possível processar a importação do arquivo.</SubText>
        <ErrorBox>{importError}</ErrorBox>
        <ButtonsDiv>
          <SecondaryButton onClick={handleGoBack}>Voltar</SecondaryButton>
          <FinishButton onClick={handleCloseModal}>Fechar</FinishButton>
        </ButtonsDiv>
      </Container>
    )
  }

  if (isInitialLoading) {
    return (
      <Container>
        <HeaderDiv>
          <HeaderText>Processando planilha...</HeaderText>
          <CloseDiv onClick={handleCloseModal}>
            <CloseImg src={cross} alt='Close tab' />
          </CloseDiv>
        </HeaderDiv>
        <SubText>
          Aguarde, estamos processando e validando os dados no servidor antes de iniciar o progresso.
        </SubText>
        <LoadingContainer>
          <OrdenoLoading size="lg" text="Carregando dados da planilha..." />
          <LoadingBadge>
            Validando registros e conectando ao serviço em tempo real...
          </LoadingBadge>
        </LoadingContainer>
      </Container>
    )
  }

  return (
    <Container>
      <HeaderDiv>
        <HeaderText>Importação em andamento...</HeaderText>
        <CloseDiv onClick={handleCloseModal}>
          <CloseImg src={cross} alt='Close tab' />
        </CloseDiv>
      </HeaderDiv>
      <SubText>Esse processo pode levar alguns minutos.</SubText>
      <ProgressBar completion={stockPercentage} />
      <ul>
        <ListItem>
          Linhas processadas com <SuccessText>sucesso</SuccessText>:{' '}
          {successLines}
        </ListItem>
        <ListItem>
          Linhas processadas com <ErrorText>erro</ErrorText>: {errorLines}
        </ListItem>
        <ListItem>
          Linhas criadas com sucesso no banco: {createdInDataBaseLines}
        </ListItem>
        <ListItem>
          Linhas atualizadas com sucesso no banco: {updatedInDataBaseLines}
        </ListItem>
        <ListItem>
          Linhas atualizadas com sucesso na omie: {updatedInOmieLines}
        </ListItem>
      </ul>
      {(errorRecordsList.length > 0 || updatedRecordsList.length > 0 || stockPercentage === 100) && (
        <LogSection>
          <LogHeader>
            <LogTitle>
              Detalhamento de Registros
            </LogTitle>
            <LogTabs>
              <LogTab
                type="button"
                $type="error"
                $active={activeLogTab === 'errors'}
                onClick={() => setActiveLogTab('errors')}
              >
                Erros ({errorRecordsList.length})
              </LogTab>
              <LogTab
                type="button"
                $type="updated"
                $active={activeLogTab === 'updated'}
                onClick={() => setActiveLogTab('updated')}
              >
                Atualizados ({updatedRecordsList.length})
              </LogTab>
            </LogTabs>
          </LogHeader>

          <LogList>
            {activeLogTab === 'errors' ? (
              errorRecordsList.length > 0 ? (
                errorRecordsList.map((errItem, idx) => (
                  <LogCard key={`err-${idx}`} $type="error">
                    <LogCardTop>
                      <LogBadge>Linha {errItem.line}</LogBadge>
                      {errItem.code && <LogCode>Código: {errItem.code}</LogCode>}
                    </LogCardTop>
                    <LogReason>{errItem.reason || 'Erro não especificado ao cadastrar registro.'}</LogReason>
                  </LogCard>
                ))
              ) : (
                <LogEmpty>Nenhum erro registrado nesta importação.</LogEmpty>
              )
            ) : updatedRecordsList.length > 0 ? (
              updatedRecordsList.map((updItem, idx) => (
                <LogCard key={`upd-${idx}`} $type="updated">
                  <LogCardTop>
                    <LogBadge>Linha {updItem.line}</LogBadge>
                    {updItem.code && <LogCode>Código: {updItem.code}</LogCode>}
                    {updItem.name && <LogItemName title={updItem.name}>• {updItem.name}</LogItemName>}
                  </LogCardTop>
                  <LogSuccessMessage>Registro existente atualizado com sucesso no banco de dados.</LogSuccessMessage>
                </LogCard>
              ))
            ) : (
              <LogEmpty>Nenhum registro precisou ser atualizado nesta importação.</LogEmpty>
            )}
          </LogList>
        </LogSection>
      )}
      <ButtonsDiv>
        {showButton ? (
          <FinishButton onClick={() => window.location.reload()}>
            Concluir
          </FinishButton>
        ) : (
          <DisabledFinishButton>Concluir</DisabledFinishButton>
        )}
      </ButtonsDiv>
    </Container>
  )
}

export default FollowingStep
